<template>
  <div class="tarifas-form-wrapper pb-16 pt-2">
    <v-row>
      <!-- COLUMNA IZQUIERDA: Información General -->
      <v-col md="5" cols="12">
        <v-card class="elevation-1 rounded-lg mb-4">
          <v-card-title class="pb-2">
            <span class="text-subtitle-1 font-weight-bold">Información General</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-row dense>
              <v-col cols="12">
                <v-select label="Temporada" :items="compTemps" v-model="Temporada"
                  :error-messages="errors.temporada ? errors.temporada : ''" item-value="id" item-text="NombreCompleto"
                  outlined dense>
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-autocomplete label="Nombre de tarifa"
                  :error-messages="errors.Subcategoria ? errors.Subcategoria : ''" :items="subCate" v-model="cateTarifa"
                  item-value="id" item-text="text" outlined dense>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center justify-space-between mb-1">
                  <span class="text-caption text-muted font-weight-bold">Segmento de Tarifa</span>
                  <v-switch v-model="sobrescribirSegmento" label="Sobrescribir" dense hide-details class="mt-0 pt-0"
                    small></v-switch>
                </div>
                <div v-if="!sobrescribirSegmento" class="pa-2 rounded mb-3"
                  style="background-color: #f1f5f9; border: 1px solid #cbd5e1;">
                  <span class="text-body-2">{{ nombreSegmentoOriginal || 'Sin segmento asignado' }}</span>
                </div>
                <v-autocomplete v-else label="Seleccionar Segmento" :items="segmentosReserva" v-model="segmentoEditado"
                  item-value="id" item-text="nm" outlined dense hide-details class="mb-3">
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center justify-space-between mb-1">
                  <span class="text-caption text-muted font-weight-bold">Mercado de Reserva</span>
                  <v-switch v-model="sobrescribirMercado" label="Sobrescribir" dense hide-details class="mt-0 pt-0"
                    small></v-switch>
                </div>
                <div v-if="!sobrescribirMercado" class="pa-2 rounded mb-3"
                  style="background-color: #f1f5f9; border: 1px solid #cbd5e1;">
                  <span class="text-body-2">{{ nombreMercadoOriginal || 'Sin mercado asignado' }}</span>
                </div>
                <v-autocomplete v-else label="Seleccionar Mercado (Opcional)" :items="mercadosReserva"
                  v-model="mercadoEditado" item-value="id" item-text="nm" outlined dense clearable hide-details
                  class="mb-3">
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="Iid" label="Clave identificadora" outlined dense
                  placeholder="Ej. T-VER-01"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select label="Agencias aplicables" :error-messages="errors.accesso ? errors.accesso : ''"
                  :items="accessArray" v-model="accesos" multiple item-value="id" item-text="text" outlined dense
                  small-chips deletable-chips>
                </v-select>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="elevation-1 rounded-lg">
          <v-card-title class="pb-2">
            <span class="text-subtitle-1 font-weight-bold">Color Identificador</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-sheet dark :color="modelColor"
              class="pa-4 rounded-lg d-flex align-center justify-space-between mb-3 elevation-2">
              <span class="text-h6 mb-0">{{ modelColor }}</span>
              <v-btn small depressed color="rgba(255,255,255,0.2)"
                @click="tempColor = modelColor; changingColor = true">
                Cambiar color
              </v-btn>
            </v-sheet>
            <v-dialog v-model="changingColor" max-width="350">
              <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">Seleccionar Color</v-card-title>
                <v-card-text>
                  <v-color-picker mode="hexa" v-model="tempColor" class="elevation-0 unset"
                    style="display: unset;"></v-color-picker>
                </v-card-text>
                <v-card-actions class="pt-0 px-4 pb-4">
                  <v-spacer></v-spacer>
                  <v-btn text color="grey" @click="changingColor = false">Cancelar</v-btn>
                  <v-btn depressed color="primary"
                    @click="modelColor = tempColor; changingColor = false; onSelectColor(tempColor)">Confirmar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- COLUMNA DERECHA: Tabs de Configuración -->
      <v-col md="7" cols="12">
        <v-card class="elevation-1 rounded-lg mb-8">
          <v-tabs v-model="tab" color="primary" background-color="transparent" grow>
            <v-tab><i class="lni lni-coin mr-2"></i> Precios</v-tab>
            <v-tab><i class="lni lni-cogs mr-2"></i> Configuración</v-tab>
          </v-tabs>
          <v-divider></v-divider>

          <v-tabs-items v-model="tab" class="bg-transparent">
            <!-- TAB PRECIOS -->
            <v-tab-item>
              <v-card-text class="pt-4">
                <div class="mb-4">
                  <span class="text-subtitle-2 text-muted">Días de aplicación:</span>
                  <div class="d-flex flex-wrap mt-2" style="gap: 8px;">
                    <v-btn small depressed :color="days.lun ? 'primary' : 'grey lighten-3'"
                      :class="{ 'white--text': days.lun }" @click="days.lun = !days.lun">LUN</v-btn>
                    <v-btn small depressed :color="days.mar ? 'primary' : 'grey lighten-3'"
                      :class="{ 'white--text': days.mar }" @click="days.mar = !days.mar">MAR</v-btn>
                    <v-btn small depressed :color="days.mie ? 'primary' : 'grey lighten-3'"
                      :class="{ 'white--text': days.mie }" @click="days.mie = !days.mie">MIE</v-btn>
                    <v-btn small depressed :color="days.jue ? 'primary' : 'grey lighten-3'"
                      :class="{ 'white--text': days.jue }" @click="days.jue = !days.jue">JUE</v-btn>
                    <v-btn small depressed :color="days.vie ? 'primary' : 'grey lighten-3'"
                      :class="{ 'white--text': days.vie }" @click="days.vie = !days.vie">VIE</v-btn>
                    <v-btn small depressed :color="days.sab ? 'primary' : 'grey lighten-3'"
                      :class="{ 'white--text': days.sab }" @click="days.sab = !days.sab">SAB</v-btn>
                    <v-btn small depressed :color="days.dom ? 'primary' : 'grey lighten-3'"
                      :class="{ 'white--text': days.dom }" @click="days.dom = !days.dom">DOM</v-btn>
                  </div>
                </div>

                <v-row dense class="align-center rounded-lg pa-3 mb-4"
                  style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
                  <v-col cols="12" sm="6">
                    <v-select label="Tipo de juego" :items="tiposJuego" v-model="tipoJuego" item-value="id"
                      item-text="nombre" outlined dense hide-details class="mb-2" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select label="Horario" v-model="Horario" :items="Horarios" item-value="id"
                      item-text="NombreCompleto" outlined dense hide-details class="mb-2"></v-select>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field type="number" v-model="precioContable" label="P. Contable" outlined dense hide-details
                      prefix="$"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field type="number" v-model="precio" label="P. Venta" outlined dense hide-details
                      prefix="$"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-select v-model="moneda"
                      :items="[{ value: $Currencies.getCurrencyDefault(), text: $Currencies.getCurrencyDefault() }, { value: 'USD', text: 'USD' }]"
                      outlined dense hide-details></v-select>
                  </v-col>
                  <v-col cols="12" class="text-right mt-2">
                    <v-btn color="primary" depressed @click="addPrecio()">
                      <i class="lni lni-plus mr-1"></i> Agregar Precio
                    </v-btn>
                  </v-col>
                </v-row>

                <div class="d-flex align-center justify-space-between mb-3">
                  <span class="text-subtitle-2 font-weight-bold">Precios configurados ({{ PreciosList.length }})</span>
                </div>

                <v-data-table :headers="[
                  { text: 'Modalidad / Días', value: 'modalidad' },
                  { text: 'Horario', value: 'horarioNombre' },
                  { text: 'P. Contable', value: 'PcoCon' },
                  { text: 'P. Venta', value: 'PcoVen' },
                  { text: '', value: 'actions', sortable: false, align: 'right' }
                ]" :items="PreciosList" hide-default-footer class="elevation-0"
                  style="border: 1px solid #e2e8f0; border-radius: 8px;" dense>
                  <template v-slot:item.modalidad="{ item }">
                    <span class="text-caption font-weight-bold">{{ item.modalidadNombre }}</span><br>
                    <span class="text-caption text-muted">{{ item.textDias }}</span>
                  </template>
                  <template v-slot:item.PcoCon="{ item }">
                    <div v-if="item.editing">
                      <v-text-field type="number" v-model="item.PcoCon" outlined dense hide-details
                        style="min-width: 80px; max-width: 90px;"></v-text-field>
                    </div>
                    <div v-else class="d-flex align-center">
                      <span class="mr-2">{{ item.PcoCon }} {{ item.Moneda }}</span>
                      <v-btn icon x-small color="primary" @click="item.editing = true"><i
                          class="lni lni-pencil"></i></v-btn>
                    </div>
                  </template>
                  <template v-slot:item.PcoVen="{ item }">
                    <div v-if="item.editing" class="d-flex align-center">
                      <v-text-field type="number" v-model="item.PcoVen" outlined dense hide-details class="mr-1"
                        style="min-width: 80px; max-width: 90px;"></v-text-field>
                      <v-select v-model="item.Moneda"
                        :items="[{ value: $Currencies.getCurrencyDefault(), text: $Currencies.getCurrencyDefault() }, { value: 'USD', text: 'USD' }]"
                        outlined dense hide-details style="max-width: 80px;"></v-select>
                    </div>
                    <div v-else class="d-flex align-center">
                      <span class="font-weight-bold mr-2">{{ item.PcoVen }} {{ item.Moneda }}</span>
                      <v-btn icon x-small color="primary" @click="item.editing = true"><i
                          class="lni lni-pencil"></i></v-btn>
                    </div>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn v-if="item.editing" icon small color="success"
                      @click="changePrecio(item.modDias.join('-'), item.modalidadId, item.horarioId, item.PcoCon, item.PcoVen, item.Moneda); item.editing = false;">
                      <i class="lni lni-checkmark"></i>
                    </v-btn>
                    <v-btn icon small color="error"
                      @click="deletePrecio(item.modDias.join('-'), item.modalidadId, item.horarioId)">
                      <i class="lni lni-trash"></i>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-tab-item>

            <!-- TAB CONFIGURACIÓN -->
            <v-tab-item>
              <v-card-text class="pt-4">
                <span class="text-subtitle-2 font-weight-bold mb-3 d-block">Planes de membresía aplicables</span>
                <v-row dense class="align-center mb-4">
                  <v-col cols="12" sm="8">
                    <v-autocomplete v-model="planToAdd" label="Seleccionar plan"
                      :error-messages="errors.planes ? errors.planes : ''" item-value="Id" item-text="Nomb"
                      :items="PlanesMembresias" outlined dense hide-details>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4" class="text-right">
                    <v-btn color="primary" depressed block @click="addPlan()">
                      <i class="lni lni-plus mr-1"></i> Añadir
                    </v-btn>
                  </v-col>
                </v-row>

                <div class="d-flex mb-3">
                  <v-btn small text color="primary" @click="addAllPlan()" class="mr-2"><i
                      class="lni lni-checkmark-circle mr-1"></i>
                    Agregar todos</v-btn>
                  <v-btn small text color="error" @click="quitAllPlan()"><i class="lni lni-close mr-1"></i> Quitar
                    todos</v-btn>
                </div>

                <v-data-table :headers="[
                  { text: 'Nombre del Plan', value: 'Nomb' },
                  { text: '', value: 'actions', sortable: false, align: 'right' }
                ]" :items="SoloPlanes ? SoloPlanes.map(p => $pgsHelper.getById(PlanesMembresias, 'Id', p)) : []"
                  hide-default-footer class="elevation-0" style="border: 1px solid #e2e8f0; border-radius: 8px;" dense>
                  <template v-slot:item.Nomb="{ item }">
                    <span class="font-weight-medium">{{ item ? item.Nomb : '' }}</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn v-if="item" icon small color="error" @click="deletePlan(item.Id)">
                      <i class="lni lni-trash-can"></i>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <!-- FOOTER FLOTANTE -->
    <div class="footer-actions">
      <v-card elevation="4" class="rounded-t-xl px-4 py-3 d-flex justify-end align-center" style="width: 100%;">
        <v-btn large color="success" depressed min-width="150" @click="checkForm()">
          <i class="lni lni-save mr-2"></i> Guardar Tarifa
        </v-btn>
      </v-card>
    </div>
  </div>
</template>

<script>
import MembresiaPlan from "../../../clases/Membresias/MembresiaPlan.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "tarifasForm",
  components: {},
  props: ["edit", "dataEdit", "temporadas", "subCate", "accessArray", "tarifarioId", "tarifarios"],
  data() {
    return {
      Mercado: "",
      sobrescribirSegmento: false,
      segmentoEditado: "",
      sobrescribirMercado: false,
      mercadoEditado: "",
      PlanesMembresias: [],
      SoloPlanes: null,
      planToAdd: "",
      tab: "0",
      defaultColor: true,
      Color: "#4895f5",
      modelColor: "4895f5",
      tempColor: "",
      Id: "",
      //Turista: false,
      Iid: "",
      Tarifario: "",
      Temporada: "",
      subcategoria: [],
      cateTarifa: "",
      MainDepartamento: "",
      Precios: {},
      accesos: [],
      PreciosList: [],
      tiposJuego: [],
      selectedTemporada: "",
      Horarios: [],
      tipoJuego: "",
      Horario: "",
      HoraInicial: "",
      HoraFinal: "",
      changingColor: false,
      days: {
        dom: true,
        lun: true,
        mar: true,
        mie: true,
        jue: true,
        vie: true,
        sab: true,
      },
      minDate: "06:00",
      maxDate: "18:00",
      moneda: "USD",
      precio: "",
      precioContable: "",
      errors: {},
    };
  },
  methods: {
    addPlan() {
      this.errors = [];
      let valid = true;

      if (!this.planToAdd) {
        this.errors.planes = "Por favor, agregue un plan";
        valid = false;
      }

      if (valid) {
        if (!this.SoloPlanes) {
          this.SoloPlanes = [];
        }
        if (!this.SoloPlanes.includes(this.planToAdd)) {
          this.SoloPlanes.push(this.planToAdd);
        }
      }
    },
    addAllPlan() {
      this.$swal({
        title: "¿Deseas agregar todos los planes",
        text: "Se agregarán todos los planes disponibles a la tarifa",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          if (!this.SoloPlanes) {
            this.SoloPlanes = [];
          }
          this.PlanesMembresias.forEach((item) => {
            this.SoloPlanes.push(item.Id);
          });
        },
      });
    },
    quitAllPlan() {
      this.$swal({
        title: "¿Deseas eliminar todos los planes",
        text: "Se eliminarán todos los planes actuales de la tarifa",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.SoloPlanes = null;
        },
      });
    },
    deletePlan(id) {
      let planToDelete = this.SoloPlanes.indexOf(id);
      this.SoloPlanes.splice(planToDelete, 1);
    },
    onSelectColor() {
      this.Color = this.modelColor || this.modelColor;
    },
    deletePrecio(dias, idModalidad, idHorario) {
      delete this.Precios[dias][idModalidad][idHorario];
      this.PreciosList = this.generateListPrecio();
      this.$forceUpdate();
    },
    changePrecio(dias, idModalidad, idHorario, precioContable, precioVenta, moneda) {
      this.Precios[dias][idModalidad][idHorario].PcoCon = Number(precioContable);
      this.Precios[dias][idModalidad][idHorario].PcoVen = Number(precioVenta);
      this.Precios[dias][idModalidad][idHorario].Moneda = moneda;
      this.PreciosList = this.generateListPrecio();
      this.$forceUpdate();
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.MainDepartamento + "/Horarios"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({
          id: element[0],
          NombreCompleto:
            element[1].Nombre +
            " : " +
            element[1].HoraInicio +
            " - " +
            element[1].HoraTermino,
          ...element[1],
        });
      });
    },
    addPrecio() {
      let valid = true;
      this.errors = [];

      if (!this.tipoJuego) {
        this.errors.tjuego = "El tipo de juego es obligatorio";
        valid = false;
      } else {
        this.errors.tjuego = false;
      }

      let daysSelected = Object.entries(this.days);
      let daysIsSelected = false;
      daysSelected.forEach((day, index) => {
        if (day[1]) {
          daysIsSelected = true;
        }
      });

      if (!daysIsSelected) {
        this.errors.days = "Los dias de la tarifa es requerido";
        valid = false;
      } else {
        this.errors.days = false;
      }
      if (!this.precio) {
        this.errors.precio = "El precio de la tarifa es requerido";
        valid = false;
      } else {
        this.errors.precio = false;
      }
      if (!this.precioContable) {
        this.errors.precioContable =
          "El precio contable de la tarifa es requerido";
        valid = false;
      } else {
        this.errors.precioContable = false;
      }
      if (!this.Horario) {
        this.errors.horario = "El horario es requerido";
        valid = false;
      } else {
        this.errors.horario = false;
      }

      let days = Object.entries(this.days);
      let arrayDays = [];
      days.forEach((day, index) => {
        if (day[1]) {
          arrayDays.push(index);
        }
      });

      if (valid) {
        let validHour = this.validateHorarios(
          this.tipoJuego,
          this.Horario,
          arrayDays
        );
        if (validHour) {
          this.$swal(
            "No puedes seleccionar este Horario",
            "el horario seleccionado tienen conflicto con otros precios del tarifario",
            "error"
          );
          return false;
        }

        if (!this.Precios[arrayDays.join("-")]) {
          this.Precios[arrayDays.join("-")] = {};
        }

        if (!this.Precios[arrayDays.join("-")][this.tipoJuego]) {
          this.Precios[arrayDays.join("-")][this.tipoJuego] = {};
        }

        this.Precios[arrayDays.join("-")][this.tipoJuego][this.Horario] = {
          PcoCon: parseFloat(this.precioContable),
          PcoVen: parseFloat(this.precio),
          Moneda: this.moneda,
        };

        this.PreciosList = this.generateListPrecio();
        this.$forceUpdate;
      } else {
        this.$swal(
          "Complete la información necesaria para agregar un precio",
          "Verifique la información",
          "error"
        );
      }
    },
    generateListPrecio() {
      let tableHorarios = [];
      let precios = this.Precios;

      let dias = Object.entries(precios);
      dias.forEach((mod) => {
        let modDias = mod[0].split("-");
        let textDias = "";
        modDias.forEach((element) => {
          textDias += " " + this.$pgsHelper.getDayName(element, "Simple");
        });

        let modalidades = Object.entries(mod[1]);
        modalidades.forEach((modalidad) => {
          let idModalidad = modalidad[0];
          let dataModalidad = modalidad[1];
          let horarios = Object.entries(dataModalidad);
          horarios.forEach((precios) => {
            tableHorarios.push({
              textDias: textDias,
              modDias: modDias,
              modalidadId: idModalidad,
              horarioId: precios[0],
              editing: false,
              modalidadNombre: this.$pgsHelper.getById(
                this.tiposJuego,
                "id",
                idModalidad
              ).nombre,
              horarioNombre: this.$pgsHelper.getById(
                this.Horarios,
                "id",
                precios[0]
              ).Nombre,
              ...precios[1],
            });
          });
        });
      });
      return tableHorarios;
    },
    validateHorarios(modalidad, horario, arrayDays) {
      let isSameHour = false;
      this.PreciosList.forEach((element) => {
        if (
          element.modalidadId == modalidad &&
          element.modDias.join("-") == arrayDays.join("-")
        ) {
          let elementHoraData = this.$pgsHelper.getById(
            this.Horarios,
            "id",
            element.horarioId
          );
          let formHoraData = this.$pgsHelper.getById(
            this.Horarios,
            "id",
            horario
          );

          if (
            element.modalidadId == modalidad &&
            element.modDias.join("-") == arrayDays.join("-") &&
            horario == element.horarioId
          ) {
            isSameHour = true;
          }

          if (
            moment(formHoraData.HoraInicio, "HH:mm:ss").isBetween(
              moment(elementHoraData.HoraInicio, "HH:mm:ss").format("HH:mm"),
              moment(elementHoraData.horaTermino, "HH:mm:ss").format("HH:mm")
            )
          ) {
            isSameHour = true;
          }
          if (
            moment(formHoraData.HoraTermino, "HH:mm:ss").isBetween(
              moment(elementHoraData.HoraInicio, "HH:mm:ss").format("HH:mm"),
              moment(elementHoraData.horaTermino, "HH:mm:ss").format("HH:mm")
            )
          ) {
            isSameHour = true;
          }
          if (
            (moment(formHoraData.HoraInicio, "HH:mm:ss").format("HH:mm") ==
              moment(elementHoraData.HoraInicio, "HH:mm:ss").format("HH:mm") ||
              moment(formHoraData.HoraInicio, "HH:mm:ss").format("HH:mm") ==
              moment(elementHoraData.horaTermino, "HH:mm:ss").format(
                "HH:mm"
              )) &&
            (moment(formHoraData.HoraTermino, "HH:mm:ss").format("HH:mm") ==
              moment(elementHoraData.HoraInicio, "HH:mm:ss").format("HH:mm") ||
              moment(formHoraData.HoraTermino, "HH:mm:ss").format("HH:mm") ==
              moment(elementHoraData.horaTermino, "HH:mm:ss").format("HH:mm"))
          ) {
            isSameHour = true;
          }
        }
      });
      return isSameHour;
    },
    checkForm: function (e) {
      let valid = true;
      // confirma precios que quedaron en edicion sin presionar el check
      this.PreciosList.filter((p) => p.editing).forEach((p) => {
        this.changePrecio(p.modDias.join("-"), p.modalidadId, p.horarioId, p.PcoCon, p.PcoVen, p.Moneda);
      });
      this.subcategoria = [];
      if (this.cateTarifa != "") {
        this.subcategoria = [this.cateTarifa];
      }

      this.errors = [];

      if (!this.Temporada) {
        this.errors.temporada = "La temporada es requerida";
        valid = false;
      } else {
        this.errors.temporada = false;
      }

      // Lógica para guardar el segmento de la tarifa
      this.Segmento = this.sobrescribirSegmento ? this.segmentoEditado : (this.currentTarifario ? this.currentTarifario.Segmento : "");

      // Lógica para guardar el mercado de la tarifa
      this.Mercado = this.sobrescribirMercado
        ? (this.mercadoEditado || "")
        : (this.currentTarifario ? (this.currentTarifario.Mercado || "") : "");


      if (this.subcategoria.length == 0) {
        this.errors.Subcategoria = "La categoria es requerida";
        valid = false;
      } else {
        this.errors.Subcategoria = false;
      }

      if (this.accesos.length == 0) {
        this.errors.accesso = "Los accesos es requerido";
        valid = false;
      } else {
        this.errors.accesso = false;
      }

      let arrayPrice = Object.entries(this.Precios);
      if (arrayPrice.length == 0) {
        valid = false;
        this.$swal("Agregue horarios y precios a la tarifa", "", "error");
      }
      if (valid) {
        this.$emit("successDataHorario", this.$data);
      }
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.MainDepartamento + "/Modalidades"
      );
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
        this.valor = element[0];
        this.$emit("input", element[0]);
      });
    },
    ...mapActions("TarifasStore", ["getMercadosReserva"]),
  },
  computed: {
    // initialHour() {
    //   if (this.HoraInicial === "") {
    //     return this.minDate;
    //   } else {
    //     let hour = new moment(this.HoraInicial);
    //     hour.add(10, "minutes");
    //     return hour.format("HH:mm");
    //   }
    // },
    compTemps() {
      let temporadasValidas = []
      this.temporadas.forEach((temp) => {
        if (temp.id !== "ALL") {
          temporadasValidas.push(temp)
        }

      })
      return temporadasValidas
    },
    ...mapGetters("SegmentosReserva", {
      segmentosReserva: "getSegmentosReserva",
    }),
    ...mapGetters("TarifasStore", {
      mercadosReserva: "getMercadosReserva",
    }),
    currentTarifario() {
      if (!this.tarifarios || !this.tarifarioId) return null;
      return this.tarifarios.find(t => t.Id === this.tarifarioId || t.value === this.tarifarioId);
    },
    nombreSegmentoOriginal() {
      if (this.currentTarifario && this.currentTarifario.Segmento && this.segmentosReserva) {
        const segmentoInfo = this.segmentosReserva.find(f => f.id === this.currentTarifario.Segmento);
        return segmentoInfo ? segmentoInfo.nm : 'Desconocido';
      }
      return '';
    },
    nombreMercadoOriginal() {
      if (this.currentTarifario && this.currentTarifario.Mercado && this.mercadosReserva) {
        const mercadoInfo = this.mercadosReserva.find(f => f.id === this.currentTarifario.Mercado);
        return mercadoInfo ? (mercadoInfo.nm || mercadoInfo.nombre) : 'Desconocido';
      }
      return '';
    }
  },
  watch: {},
  beforeMount: function () {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
  },
  async mounted() {
    this.PlanesMembresias = MembresiaPlan.getMembresiasPlanList();
    await this.getHorarios();
    await this.getTiposJuego();
    this.getMercadosReserva();
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.Temporada = this.dataEdit.Temporada;
      this.subcategoria = this.dataEdit.Subcategoria;
      this.cateTarifa = this.dataEdit.Subcategoria[0];
      this.Precios = this.dataEdit.Precios;
      //this.Turista = this.dataEdit.Turista;
      this.Iid = this.dataEdit.Iid;
      this.Mercado = this.dataEdit.Mercado || "";
      (this.Color = this.dataEdit.Color),
        (this.modelColor = this.dataEdit?.Color || "#4895f5"),
        (this.accesos = this.dataEdit.Accesos);
      this.PreciosList = this.generateListPrecio();
      this.SoloPlanes = this.dataEdit.SoloPlanes;

      // Lógica de edición para segmento
      if (this.dataEdit.Segmento) {
        // Verificar si es diferente al del tarifario padre
        const originalParentSegmento = this.currentTarifario ? this.currentTarifario.Segmento : null;
        if (originalParentSegmento !== this.dataEdit.Segmento) {
          this.sobrescribirSegmento = true;
          this.segmentoEditado = this.dataEdit.Segmento;
        } else {
          this.sobrescribirSegmento = false;
          this.segmentoEditado = this.dataEdit.Segmento;
        }
      }

      // Lógica de edición para mercado
      if (this.dataEdit.Mercado) {
        // Verificar si es diferente al del tarifario padre
        const originalParentMercado = this.currentTarifario ? this.currentTarifario.Mercado : null;
        if (originalParentMercado !== this.dataEdit.Mercado) {
          this.sobrescribirMercado = true;
          this.mercadoEditado = this.dataEdit.Mercado;
        } else {
          this.sobrescribirMercado = false;
          this.mercadoEditado = this.dataEdit.Mercado;
        }
      }
    }
  },
};
</script>

<style scoped>
.unset {
  display: unset !important;
}

.selectDay {
  background-color: #2185d0 !important;
  color: white;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.footer-actions {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  z-index: 10;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.footer-actions>.v-card {
  pointer-events: auto;
  max-width: 90%;
}
</style>
